import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function SarcoidosisDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Sarcoidosis Specific Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Date of diagnosis?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.dateOfDiagnosis.referToAttachments}>
                        <p>{formatDateMonthYear(questions.dateOfDiagnosis.value)}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please confirm the staging of the disease at initial diagnosis:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.initialStage.referToAttachments}>
                        <p>{questions.initialStage.value}</p>

                        <Question
                            show={questions.initialStage.other != ''}
                            answer={questions.initialStage.other}
                        >
                            Other:
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>


                <QuestionWrapper number='3'>
                    <Question>Have any complications ever manifested?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.complications.referToAttachments}>
                        <p>{questions.complications.value}</p>

                        {questions.complications.value === 'Yes' && (
                            <>
                                <QuestionWrapper>
                                    <Question
                                        answer={questions.complications.details}
                                    >
                                        If yes, please specify:
                                    </Question>
                                </QuestionWrapper>

                                {questions.complications.details === 'Other' && (
                                    <QuestionWrapper>
                                        <Question
                                            answer={questions.complications.other}
                                        >
                                            If other, please give details:
                                        </Question>
                                    </QuestionWrapper>
                                )}

                                {/* Extra question wrapper for spacing */}
                                <QuestionWrapper /> 
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Based on the latest specialist review, are the lesions:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.lesions.referToAttachments}>
                        <p>{questions.lesions.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Does the current treatment regimen include any of the following:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatment.referToAttachments}>
                        <QuestionWrapper>
                            <Question
                                answer={questions.treatment.corticosteroids}
                            >
                                Corticosteroids:
                            </Question>
                        </QuestionWrapper>

                        <QuestionWrapper>
                            <Question
                                answer={questions.treatment.secondLineAgents}
                            >
                                Anti-TNFs, DMARDs or any other second line agents:
                            </Question>
                        </QuestionWrapper>

                        <QuestionWrapper>
                            <Question show={questions.treatment.secondLineAgents === 'Yes'}>
                                If yes, please confirm details:
                            </Question>
                            <p>{questions.treatment.other}</p>
                        </QuestionWrapper>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Please confirm the most recent result of the below:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.results.referToAttachments}>

                        <QuestionsContainer>
                            <QuestionWrapper number='a'>
                                <Question
                                    answer={questions.results.cxr.value}
                                >
                                    CXR:
                                </Question>

                                {questions.results.cxr.value == 'Yes' && (
                                    <>
                                        <p>If yes, please confirm details:</p>

                                        <Question
                                            answer={formatDateMonthYear(questions.results.cxr.date)}
                                        >
                                            Date:
                                        </Question>

                                        <Question
                                            answer={questions.results.cxr.normal}
                                        >
                                            Normal:
                                        </Question>

                                        <Question
                                            show={questions.results.cxr.normal === 'No'}
                                            answer={questions.results.cxr.detailsIfAbnormal}
                                        >
                                            If no, please confirm nature of abnormality:
                                        </Question>
                                    </>
                                )}
                            </QuestionWrapper>

                            <QuestionWrapper number='b'>
                                <Question>FEV1:</Question>
                                <p>{`PFTs - FEV1 result <60% predicted / PEF = 600 (litres per minute or L/min)`}</p>

                                <Question
                                    answer={formatDateMonthYear(questions.results.fev1.date)}
                                >
                                    Date:
                                </Question>

                                <Question
                                    answer={questions.results.fev1.result}
                                >
                                    Result:
                                </Question>
                            </QuestionWrapper>

                            <QuestionWrapper number='c'>
                                <Question>PEF:</Question>

                                {!questions.results.pef.none && !questions.results.pef.unknown && (
                                    <>
                                        <Question
                                            answer={formatDateMonthYear(questions.results.pef.date)}
                                            newLine
                                        >
                                            Date:
                                        </Question>

                                        <Question
                                            answer={questions.results.pef.result}
                                            newLine
                                        >
                                            Result:
                                        </Question>
                                    </>
                                )}

                                <Question
                                    answer={questions.results.pef.none ? 'Yes' : 'No'}
                                    newLine
                                >
                                    None:
                                </Question>

                                <Question
                                    answer={questions.results.pef.unknown ? 'Yes' : 'No'}
                                    newLine
                                >
                                    Unknown:
                                </Question>
                            </QuestionWrapper>

                            <QuestionWrapper number='d'>
                                <Question
                                    answer={questions.results.ctScan.value}
                                >
                                    CT Scan:
                                </Question>

                                {questions.results.ctScan.value == 'Yes' && (
                                    <>
                                        <p>If yes, please confirm details:</p>

                                        <Question
                                            answer={formatDateMonthYear(questions.results.ctScan.date)}
                                        >
                                            Date:
                                        </Question>

                                        <Question
                                            answer={questions.results.ctScan.normal}
                                        >
                                            Normal:
                                        </Question>

                                        <Question
                                            show={questions.results.ctScan.normal === 'No'}
                                            answer={questions.results.ctScan.detailsIfAbnormal}
                                        >
                                            If no, please confirm nature of abnormality:
                                        </Question>
                                    </>
                                )}
                            </QuestionWrapper>
                        </QuestionsContainer>





                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}